import { Typography } from '@shinetools/lumen-react'
import { ReactElement } from 'react'

export const BillsTableNoDataField = (): ReactElement => {
  return <Typography.Text>—</Typography.Text>
}
